import { gql } from '@apollo/client';

export const SIGNUP = gql(/*GraphQL*/ `
  mutation CreateUser($createUserInput: CreateUserInput!) {
     createUser(createUserInput: $createUserInput) {
     email
     name
     role
  }
}`);
